import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import LoginForm from '../../components/LoginForm/LoginForm';
import { Container, Col, Row } from '../../components/Grid';
import { connect } from 'react-redux';
import { loginThunk, resetLogin } from '../sharedActions/authActions';
import './Login.css';
import { Bounce } from 'react-awesome-reveal';
import { renderError } from '../../utils/renderError';
import PropTypes from 'prop-types';
import { withTheme } from '../higherOrderComponents/withTheme';
import studyingIcon from 'icons/studying.svg';

class LoginPage extends Component {

  componentWillUnmount() {
    this.props.resetLogin();
  }

  handleLogin = (values) => {
    // Dispatch the loginThunk with form values
    this.props.loginThunk(values);
  };

  render() {
    const { isAuthenticated, loginError, themeMode } = this.props;

    const cardStyle = {
      borderRadius: '15px',
      boxShadow: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
      backgroundColor: themeMode === 'dark' ? '#282828' : '#fff',
      color: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'inherit',
    };

    if (isAuthenticated) {
      return <Navigate to="/board" replace />;
    }

    return (
      <React.Fragment>
        <Container className="pt-5 pb-5">
          <Row className="justify-content-center">
            <Col size="12 md-6 lg-4">
              <Bounce>  
                <img
                  className="mt-4"
                  src={studyingIcon}
                  alt="login illustration"
                />
              </Bounce>
            </Col>
            <Col size="12 md-6 lg-4">
              <h1 className="montserrat mt-5 font-weight-bold">Welcome Back!</h1>
              <h3 className="montserrat mt-1">Log in to continue</h3>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col />
            <Col size="12 md-8 lg-8" className="banana">
              <LoginForm
                onSubmit={this.handleLogin}
                errorMessage={renderError(loginError)}
              />
            </Col>
            <Col />
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

LoginPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  loginError: PropTypes.string,
  loginThunk: PropTypes.func.isRequired,
  resetLogin: PropTypes.func.isRequired,
  themeMode: PropTypes.string // This comes from withTheme HOC
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loginError: state.auth.loginError
  // Remove the themeMode mapping from Redux state
});

const mapDispatchToProps = {
  loginThunk,
  resetLogin
};

// The withTheme HOC will inject the themeMode prop
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(LoginPage));
